// import Swiper, { Autoplay, Navigation } from "swiper";

// Swiper.use([Navigation]);

// document.addEventListener("DOMContentLoaded", () => {
//   const wrapper = document.querySelector(".feedbacks__wrapper");
//   if (!wrapper) return;

//   new Swiper(wrapper, {
//     slidesPerView: 1,
//     spaceBetween: 24,
//     loop: true,
//     navigation: {
//       nextEl: ".feedbacks__wrapper__button--next",
//       prevEl: ".feedbacks__wrapper__button--prev",
//     },
//     breakpoints: {
//       992: {
//         slidesPerView: 2,
//         allowTouchMove: false,
//       },
//     },
//   });

//   const textContainers = document.querySelectorAll(
//     ".feedbacks__wrapper__item__text__content"
//   );

//   if (textContainers.length === 0) return;

//   textContainers.forEach((container) => {
//     const button = container
//       .closest(".feedbacks__wrapper__item__text")
//       .querySelector(".feedbacks__wrapper__item__text__readmore");

//     const shouldShowButton = () => {
//       const isDesktop = window.innerWidth >= 768;
//       const maxLines = isDesktop ? 6 : 12;
//       const lineHeight = parseFloat(getComputedStyle(container).lineHeight);
//       return container.scrollHeight > lineHeight * maxLines;
//     };

//     const updateButtonVisibility = () => {
//       button.style.display = shouldShowButton() ? "flex" : "none";
//     };

//     updateButtonVisibility();

//     button.addEventListener("click", () => {
//       const isExpanded = container.classList.contains("expanded");
//       container.classList.toggle("expanded", !isExpanded);
//       button.classList.toggle("active", !isExpanded);
//       button.querySelector("span").textContent = isExpanded
//         ? "Читать полностью"
//         : "Скрыть";
//     });

//     window.addEventListener("resize", updateButtonVisibility);
//   });
// });

// document.addEventListener("DOMContentLoaded", () => {
//   const textContainers = document.querySelectorAll(
//     ".feedbacks__wrapper__item__text__content"
//   );

//   if (textContainers.length === 0) return;

//   textContainers.forEach((container) => {
//     const button = container
//       .closest(".feedbacks__wrapper__item__text")
//       .querySelector(".feedbacks__wrapper__item__text__readmore");
//     const content = container;

//     const shouldShowButton = () => {
//       const isDesktop = window.innerWidth >= 768;
//       const maxLines = isDesktop ? 6 : 12;
//       const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
//       return content.scrollHeight > lineHeight * maxLines;
//     };

//     const updateButtonVisibility = () => {
//       if (shouldShowButton()) {
//         button.style.display = "flex";
//       } else {
//         button.style.display = "none";
//       }
//     };

//     updateButtonVisibility();

//     button.addEventListener("click", () => {
//       const isExpanded = content.classList.contains("expanded");
//       content.classList.toggle("expanded", !isExpanded);
//       button.classList.toggle("active", !isExpanded);
//       button.querySelector("span").textContent = isExpanded
//         ? "Читать полностью"
//         : "Скрыть";
//     });

//     window.addEventListener("resize", updateButtonVisibility);
//   });
// });


import Swiper, { Navigation } from "swiper"; // Autoplay не используется — удалил

Swiper.use([Navigation]);

document.addEventListener("DOMContentLoaded", () => {
  // Инициализация слайдера
  const wrapper = document.querySelector(".feedbacks__wrapper");
  if (!wrapper) return;

  new Swiper(wrapper, {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    navigation: {
      nextEl: ".feedbacks__wrapper__button--next",
      prevEl: ".feedbacks__wrapper__button--prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        allowTouchMove: false,
      },
    },
  });

  // Инициализация кнопок "Читать полностью"
  const textContainers = document.querySelectorAll(
    ".feedbacks__wrapper__item__text__content"
  );

  if (textContainers.length === 0) return;

  textContainers.forEach((container) => {
    const button = container
      .closest(".feedbacks__wrapper__item__text")
      .querySelector(".feedbacks__wrapper__item__text__readmore");

    if (!button) return; // на случай, если кнопка не найдена

    // ✅ Исправлено: сравниваем scrollHeight с текущим max-height из CSS
    const shouldShowButton = () => {
      const computedStyle = getComputedStyle(container);
      const containerMaxHeight = parseFloat(computedStyle.maxHeight);
      // Если max-height не задан (например, none), то кнопка не нужна
      if (isNaN(containerMaxHeight)) return false;
      return container.scrollHeight > containerMaxHeight;
    };

    const updateButtonVisibility = () => {
      button.style.display = shouldShowButton() ? "flex" : "none";
    };

    // Первоначальная проверка
    updateButtonVisibility();

    // Обработчик клика по кнопке
    button.addEventListener("click", () => {
      const isExpanded = container.classList.contains("expanded");

      container.classList.toggle("expanded", !isExpanded);
      button.classList.toggle("active", !isExpanded);

      // Меняем текст кнопки
      const buttonText = button.querySelector("span");
      if (buttonText) {
        buttonText.textContent = isExpanded ? "Читать полностью" : "Скрыть";
      }
    });

    // Обновляем видимость кнопки при изменении размера окна
    window.addEventListener("resize", updateButtonVisibility);
  });
});